import moment from 'moment';

export const formatSimplifiedDate = (startDate, endDate) => {

  //Thiago, isso é necessário por conta da bagunda de GMT que se tornou esse sistema.
  const formattedStartDate = moment(startDate).add(3, 'hours').format('DD/MMM');
  const formattedEndDate = moment(endDate).add(3, 'hours').format('DD/MMM');

  const formattedRet = formattedStartDate + " à " + formattedEndDate
  return formattedRet;
}
